import { Row, Typography } from 'antd'
import React from 'react'

function ModalPoricy() {
    return (
        <div
            className='pl-2 pr-2'
            style={{
                maxHeight: 450,
                overflowX: 'hidden',
                padding: '5px'
            }}
        >
            <Row justify='center' className='pb-3'>
                <Typography.Text
                    className='size-18'
                    style={{
                        textAlign: 'center',
                        fontWeight: 500
                    }}>
                    ประกาศที่ 1/2566 <br />
                    เรื่อง"นโยบายการคุ้มครองข้อมูลส่วนบุคลสําหรับลูกค้าและผู้ใช้บริการ
                    (Data Protection Policy for Customers and Clients)"

                </Typography.Text>
                --------------------------------------------------------------------- <br /><br />
            </Row>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทไวท์พลายจํากัดบริษัทใหญ่บริษัทย่อยบริษัทร่วมบริษัทในเครือกิจการและเครือธุรกิจเดียวกัน<b className='mr-1'>("บริษัท")</b>
            มีความมุ่งมั่นที่จะดำเนินการตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กฎหมายลำดับ
            รอง ประกาศ ระเบียบ แนวทางและ/หรือคำสั่งของคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล จึงได้กำหนด
            หลักณณฑ์และหลักปฏิบัติในการเก็บรวบรวม ใช้ ประมวลผล และเปิดเผยข้อมูลส่วนบุคคลและการคุ้มครองสิทธิ
            ของเจ้าของข้อมูลส่วนบุคคล บริษัทจึงขอประกาศนโยบายการคุ้มครองข้อมูลส่วนบุคคลเพื่อใช้บังคับกับลูกค้าและ
            ผู้ใช้บริการของบริษัท ดังนี้ และขอให้ลูกค้าและผู้ใช้บริการของบริษัทศึกษารายละเอียดและเงื่อนไขของนโยบาย
            ฉบับนี้โดยละเอียด
            <br /><br />
            1. คำนิยาม
            <br /><br />
            <div className='pl-4 pr-4 pb-3'>
                <b>"การประมวลผล"</b> หมายถึง การดำเนินการใด ๆ ซึ่งกระทำต่อข้อมูลส่วนบุคคลหรือชุดข้อมูลส่วนบุคคล
                ไม่ว่าจะดยวิธีการอัโนมัติหรือไม่ เช่น การเก็บรวบรวม การบันทึก การแก้ไข การจัดระบบโครงสร้างการเก็บ
                รักษาเปลี่ยนแปลงหรือปรับเปลี่ยน การรับ พิจารณา การใช้ การเปีดเผยไม่ว่าโดยการส่งต่อ โอน เผยแพร่ หรือการ
                กระทำอื่นใดซึ่งทำให้เกิดความพร้อมใช้งาน การจัดวางหรือผสมเข้าด้วยกัน การจำกัด การลบ การทำลาย
                <br /><br />
                <b>"ข้อมูลส่วนบุคคล"</b> หมายถึง ข้อมูลใด ๆ ที่เกี่ยวกับบุคคลซึ่งทำให้สามารถระบุไปถึง "เจ้าของข้อมูลส่วน
                บุคคล (Data Subject)" ได้ไม่ว่าทางตรงหรือทางอ้อม รวมถึงข้อมูลทุกประเภทที่สามารถบ่งชี้ตัวตน ซึ่งรวมถึงแต่
                ไม่จำกัดเพียง ชื่อ นามสกุล ที่อยู่ หมายเลขโทรศัพท์ เลขประจำตัวประชาชน เลขหนังสือเดินทาง ข้อมูลออนไลน์
                ข้อมูลเอกลักษ์ณ์ทางกายภาพทางจิตใจ ทางสังคม เศรษฐกิจ วัฒนธรรม หรือข้อมูลอื่นใดที่สามารถระบุตัวตนได้
                เป็นต้น (แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ)
                <br /><br />
                <b>"ข้อมูลส่วนบุคคลที่มีความอ่อนไหว"</b>หมายถึง ข้อมูลส่วนบุคคลประเภทพิเศษ ตามมาตรา 26 ของ
                พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 เช่น ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็น
                ทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ข้อมูล
                ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ หรือข้อมูลอื่นใดที่มีลักษณะเดียวกันตามที่
                คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลกำหนด
                <br />
                <br />
                <b>"เครือกิจการหรือเครือธุรกิจเดียวกัน"</b> หมายถึง กิจการที่ผู้ประกอบกิจการที่มีอำนาจควบคุมบริหาร
                จัดการเหนือกิจการอื่น หรือกิจการที่ถูกควบคุมโดยผู้ประกอบกิจการที่มีอำนาจเหนือกิจการอื่น ในรูปแบบบริษัท
                ใหญ่ บริษัทย่อย บริษัทร่วม หรือบุคคลธรรมดาหรือนิติบุคคลที่มีความเกี่ยวข้องกันทางกฎหมาย หรือเกี่ยวข้องกัน
                เนื่องจากการประกอบกิจกรรมทางเศรษฐกิจร่วมกัน โดยใช้หลักเกณฑ์การพิจารณาตามมาตรฐานทางบัญชีอันเป็น
                ที่ยอมรับโดยทั่วไป
                <br /> <br />
                <b>"เจ้าของข้อมูลส่วนบุคคล (Data Subject)"</b>หมายถึง บุคคลธรรมดาซึ่งสามารถถูกระบุตัวตนได้โดย
                ข้อมูลส่วนบุคคลนั้น ๆ ไม่ว่าโดยทางตรงหรือทางอ้อม
                <br /> <br />
                <b>"บริษัท"</b> หมายถึง บริษัท ไวท์พลาย จำกัด บริษัทใหญ่ บริษัทย่อย บริษัทร่วม และ/หรือบริษัทในเครือ
                กิจการและเครือธุรกิจเดียวกัน
                <br /> <br />
                <b>"บริษัทย่อย"</b> หมายถึง นิติบุคคลหรือบริษัทที่มีลักษณะไดลักษณะหนึ่งดังต่อไปนี้
                <br />
                (ก) นิติบุคคลหรือบริษัทที่บริษัท ไวท์พลาย จำกัด หรือบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) มี
                อำนาจควบคุมกิจการ
                <br />
                (ข) นิติบุคคลหรือบริษัทที่นิติบุคคลหรือบริษัทตาม (ก) มีอำนาจควบคุมกิจการ
                <br />
                (ค)นิติบุคคลหรือบริษัทที่อยู่ภายใต้อำนาจควบคุมกิจการของบริษัทตาม (ข) ต่อไปเป็นทอด ๆ โดยเริ่ม
                จากการอยู่ภายใต้อำนาจควบคุมกิจการของนิติบุคคลหรือบริษัทตาม (ข)
                <br /> <br />
                <b>"บริษัทร่วม"</b> นิติบุคคลหรือบริษัทที่มีลักษณะใดลักษณะหนึ่งดังต่อไปนี้
                <br />
                (ก)นิติบุคคลหรือบริษัทที่บริษัท ไวท์พลาย จำกัด หรือบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)
                หรือบริษัทย่อยถือหุ้นไม่ว่าโดยตรงหรือโดยอ้อมรวมกันตั้งแต่ ร้อยละ 20 แต่ไม่เกินร้อยละ 50 ของจำนวนหุ้นที่มี
                สิทธิออกเสียงทั้งหมด
                <br />
                (ข) นิติบุคคลหรือบริษัทที่บริษัท ไวท์พลาย จำกัด หรือบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)
                หรือบริษัทย่อยมีอำนาจในการมีส่วนร่วมตัดสินใจเกี่ยวกับนโยบายทางการเงินและการดำเนินงาน แต่ไม่ถึงระดับที่
                จะมีอำนาจควบคุมนโยบายดังกล่าว และไม่ถือเป็นบริษัทย่อยหรือกิจการร่วมค้า
                <br /> <br />
                <b>"บริษัทใหญ่"</b> นิติบุคคลหรือบริษัทที่มีลักษณะใดลักษณะหนึ่งดังต่อไปนี้
                <br />
                (ก)นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในบริษัท ไวท์พลาย จำกัด หรือบริษัท อินเทอร์เน็ต
                ประเทศไทย จำกัด (มหาชน)
                <br />
                (ข) นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในนิติบุคคลหรือบริษัทตาม (ก)
                <br />
                (ค) นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในบริษัทตาม (ข) ต่อไปเป็นทอด ๆ โดยเริ่มจากการมี
                อำนาจควบคุมกิจการในบริษัทตาม (ข)
                <br /><br />
                <b>"อำนาจควบคุมกิจการ"</b>หมายถึง การมีความสัมพันธ์ในลักษณะใดลักษณะหนึ่งดังนี้
                <br />
                (ก) การถือหุ้นที่มีสิทธิออกเสียงในนิติบุคคลหรือบริษัทเกินกว่าร้อยละ 50 ของจำนวนสิทธิออกเสียง
                ทั้งหมดของนิติบุคคลหรือบริษัทนั้น
                <br />
                (ข) การมีอำนาจควบคุมคะแนนเสียงส่วนใหญ่ในที่ประชุมผู้ถือหุ้นของนิติบุคคลหรือบริษัทไม่ว่าโดยตรง
                หรือโดยอ้อม หรือไม่ว่าเพราะเหตุอื่นใด
                <br />
                (ค) การมีอำนาจควบคุมการแต่งตั้งหรือถอดถอนกรรมการตั้งแต่กึ่งหนึ่งของกรรมการทั้งหมด ไม่ว่า
                โดยตรงหรือโดยอ้อม


            </div>

            2. ข้อมูลที่บริษัทเก็บรวบรวม<br /> <br />
            <div className='pl-4 pr-4'>
                2.1 ข้อมูลบุคคลทั่วไป<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                บริษัทจำเป็นต้องเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคลของท่าน ซึ่งรวมถึงแต่ไม่จำกัดเพียง
                <br />
                -	ชื่อ - นามสกุล
                <br />
                -	วันเดือนปีเกิด
                <br />
                -	อายุ
                <br />
                -	ที่อยู่ ทะเบียนบ้าน รายละเอียดภูมิลำเนา
                <br />
                -	บัตรประชาชน หรือหนังสือเดินทาง
                <br />
                -	หมายเลขโทรศัพท์
                <br />
                -	หมายเลขโทรศัพท์มือถือ
                <br />
                -	เลขที่ประจำตัวผู้เสียภาษีอากร
                <br />
                -	อาชีพ สถานที่ทำงาน
                <br />
                -	ข้อมูลผู้แทนโดยชอบธรรม รายได้ของผู้แทนโดยชอบธรรม และบุคคลที่ติดต่อได้
                <br /> <br />
                2.2 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                บริษัทเก็บรวบรวมข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่าน ตามมาตรา 26 ของพระราชบัญญัติ
                คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนา
                หรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูล
                พันธุกรรม ข้อมูลชีวภาพ หรือข้อมูลอื่นใดที่มีลักษณะเดียวกัน โดยบริษัทจะเข้าถึง เก็บรวบรวม ใช้ ประมวลผล
                เปิดเผยหรือควบคุมข้อมูลส่วนบุคคลด้วยความระมัดระวังตามขอบเขตที่กฎหมายกำหนด บริษัทจะแจ้งข้อมูล
                รายละเอียดการเก็บรวบรวม ใช้ ประมวลผล และ/หรือเปิดเผย ข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อท่านก่อน
                หรือขณะที่บริษัทเก็บรวบรวมข้อมูลจากท่านภายใต้เงื่อนไขหลักเกณฑ์ที่กฎหมายกำหนด
                <br /><br />
                2.3 ข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการกระทำความผิดกฎหมาย
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                ท่านรับทราบว่า ในกรณีที่มีการกระทำความผิดตามกฎหมายเกิดขึ้น ไม่ว่าจะเป็นความผิดในทางแพ่งหรือ
                ทางอาญาหรือกฎหมายอื่นใด บริษัทมีสิทธิเก็บรวบรวมหรือใช้ข้อมูลการกระทำความผิดกฎหมายของท่านได้ โดย
                บริษัทจะเข้าถึง เก็บรวบรวม เปิดเผย หรือควบคุมข้อมูลส่วนบุคคลด้วยความระมัดระวังตามขอบเขตที่กฎหมายกำหนด
                <br /><br />
                2.4 บริษัทเก็บรวบรวม ประมวลผล ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลดังต่อไปนี้จากบุคคลภายนอก
                <br />
                <div className='pl-4 pr-4'>
                    ท่านรับทราบและยินยอมให้บริษัทเก็บรวบรวม ประมวลผล ใช้ ข้อมูลส่วนบุคคล ซึ่งรวมถึงแต่ไม่จำกัด
                    เพียง
                    <br />
                    -	ข้อมูลจากแหล่งข้อมูลสาธารณะ อาทิเช่น ข้อมูลที่ท่านเปิดเผยในสื่อสังคมออนไลน์ หรือสื่อสาธารณะ
                    (Facebook, Instagram, Twitter) และข้อมูลสาธารณะที่มีชื่อ อาชีพและข้อมูลติดต่อของท่าน
                    <br />
                    -	ข้อมูลเกี่ยวกับชื่อ นามสกุล เลขบัตรประจำตัวประชาชน บัญชีผู้ใช้ (Account) สื่อสังคมออนไลน์ เช่น
                    Facebook และ LINE รวมถึงอีเมลที่ผูกกับบัญชีผู้ใช้ IP Address ที่อยู่ วันเดือนปีเกิด เพศ อายุ รูป
                    ถ่าย อีเมล เลขที่บัญชีธนาคาร เลขที่บัตรเครดิตและบัตรเดบิต หมายเลขโทรศัพท์ ที่บริษัทอาจได้รับ
                    จากสถาบันการเงิน ตัวแทน หรือพันธมิตรทางธุรกิจของบริษัท เป็นต้น
                </div>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                บริษัทขอแจ้งให้ท่านทราบว่า เพื่อป้องกันและรักษาความปลอดภัยของบุคคลทั่วไป และเพื่อปกป้อง
                ผลประโยชน์ได้เสียของบริษัท บริษัทได้ติดตั้งกล้องวงจรปิดเพื่อความปลอดภัยภายในบริเวณบริษัท บริษัทหรือผู้
                ให้บริการซึ่งเป็นบุคคลภายนอกที่บริษัทจัดหาอาจเก็บรวบรวม ใช้ ประมวลผลข้อมูลจากภาพนิ่ง ภาพเคลื่อนไหว
                และ/หรือเสียงของท่านและข้อมูลส่วนบุคคลที่ท่นใช้และเข้ามาในบริเวณพื้นที่ของบริษัท
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                บริษัทอาจบันทึกเสียงบทสนทนาทางโทรศัพท์ เพื่อนำไปปรับปรุงและพัฒนาการให้บริการ รวมทั้งเพื่อการประชาสัมพันธ์

                <br /><br />
            </div>
            3. ข้อมูลที่บริษัทประมวลผล
            <br /> <br />
            <div className='pl-4 pr-4'>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัทประมวลผลข้อมูลส่วนบุคคลที่บริษัทรวบรวมจากท่านโดยตรงหรือเก็บรวบรวมข้อมูลส่วนบุคคลจาก
                บุคคลภายนอกตามที่ระบุไว้ในข้อ 2. ในการให้บริการ การปฏิบัติตามสัญญา การปฏิบัติตามกฎหมาย เพื่อ
                ประโยชน์โดยชอบด้วยกฎหมายของบริษัท หรือเพื่อวัตถุประสงค์ที่ระบุในข้อ 4.
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัทใช้ขั้นตอนการตัดสินใจอัตโนมัติที่จะประมวลผลข้อมูลของท่านผ่านระบบคอมพิวเตอร์ในบางกรณี
                เช่น บริษัทอาจประเมินข้อมูลส่วนบุคคลเกี่ยวกับการให้บริการหรืออื่น ๆ ท่านอาจสอบถามรายละเอียดเพิ่มเติม
                โดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ 11.

            </div>
            4. วัตถุประสงค์และเหตุผลทางกฎหมายในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลของท่าน

            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	ระบุตัวตนหรือยืนยันตัวตนของท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การลงทะเบียนการติดต่อ การสมัครใช้บริการ และ/หรือการใช้บริการของท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การซื้อขายสินค้าและ/หรือให้บริการแก่ท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การเรียกและ/หรือชำระค่าสินค้าและ/หรือค่าบริการ รวมถึงการออกใบแจ้งหนี้ การออกใบเสร็จรับเงิน
            การติดตามทวงถามให้ชำระหนี้ การรับเงินและ/หรือการคืนเงิน เป็นต้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การจัดส่งสินค้าและ/หรือบริการ รวมถึงของรางวัล ของที่ระลึก ของสมนาคุณ เป็นต้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การประเมินความพึงพอใจ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การพัฒนาสินค้าและ/หรือบริการ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การวิจัยและสถิติ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	 การเปิดบัญชีผู้ใช้งาน (Account) โปรแกรมคอมพิวเตอร์ ซอฟต์แวร์ ฮาร์ดแวร์ เว็บไซต์ แอปพลิเคชัน
            โครงข่าย และ/หรือบริการอื่นใดของบริษัท รวมถึง การลงทะเบียนผู้ใช้งาน การพิจารณาคุณสมบัติ
            ผู้ใช้งาน การประกาศรายชื่อผู้ใช้งาน การจัดทำทะเบียนผู้ใช้งาน การจัดให้มีสิทธิประโยชน์แก่ผู้ใช้งาน
            การจัดทำประวัติการใช้และ/หรือได้รับสิทธิประโยชน์ของผู้ใช้งาน และ/หรือการพัฒนาโปรแกรม
            คอมพิวเตอร์ ซอฟต์แวร์ ฮร์ดแวร์ เว็บไซต์ แอปพลิเคชัน โครงข่าย และ/หรือบริการอื่นใดของบริษัท
            เป็นต้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	การจัดส่ง นำเสนอ หรือประชาสัมพันธ์ ข้อมูลเกี่ยวกับการให้บริการของบริษัทที่เกี่ยวข้องกับบริการที่
            ท่านให้ความสนใจ ผ่านช่องทางการติดต่อต่าง ๆ ไม่ว่าจะเป็น ทางสื่อสังคมออนไลน์ ทางอีเมล หรือ
            ทางโทรศัพท์ เป็นต้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อส่งเสริม พัฒนา และปรับปรุงความสัมพันธ์ทางธุรกิจระหว่างท่านกับบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อพิจารณา ประมวลผล ทดสอบ หรือวิเคราะห์ ความสนใจของท่านเพื่อส่งเสริม พัฒนา และปรับปรุงการให้บริการของบริษัทให้ตอบสนองกับความสนใจและความต้องการของท่านอย่างสูงสุด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อฝึกอบรม ควบคุม หรือรับประกัน พนักงานและคุณภาพที่อาจเกี่ยวข้องกับการประสานงาน หรือการติดต่อผ่านช่องทางต่างๆ กับท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อจัดการ แก้ปัญหา ซักถาม และวิเคราะห์ ปัญหาที่อาจเกิดขึ้นจากการให้บริการของบริษัท โดยบริษัทจะใช้ข้อมูลดังกล่าวเพื่อความจำเป็นเท่านั้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อจัดการ ตอบคำถาม หรือตอบรับ การติดต่อสื่อสาร การร้องเรียนการใช้บริการ หรือการแสดงความคิดเห็นจากท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อชี้แจง บอกกล่าว หรือแจ้งให้ทราบถึงการปรับเปลี่ยนรูปแบบ หรือข้อมูลที่เกี่ยวข้องกับการให้บริการของบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อตรวจสอบ ปกป้อง หรือป้องกัน การกระทำใดอันไม่ถูกต้อง การละเมิด การประพฤติผิด หรือการฝ่าฝืน กฎหมาย ระเบียบ ข้อบังคับ ข้อตกลงและเงื่อนไขในการให้บริการ และเงื่อนไขอื่นใดของบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อส่งเสริม หรือประชาสัมพันธ์ในการเข้าร่วมกิจกรรมโฆษณาและกิจกรรมส่งเสริมการขายอื่นใดภายใต้เงื่อนไขของบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อวัตถุประสงค์ทางการตลาด เช่น การจัดส่งเอกสารเกี่ยวกับโปรโมชั่นต่าง ๆ การส่งข่าวสารเกี่ยวกับสินค้าบริการ งานกิจกรรม และ/หรือกิจกรรมส่งเสริมการขายของบริษัท
            ทางไปรษณีย์ อีเมล และ/หรือทางโทรศัพท์และด้วยวิธีการอื่นใด รวมถึงการดำเนินการด้านการตลาดแบบตรง เพื่อเพิ่มสิทธิประโยชน์ที่ท่านจะได้รับจากการเป็นลูกค้าของบริษัท ทั้งนี้
            ท่านสามารถเลือกที่จะไม่รับการสื่อสารเพื่อวัตถุประสงค์ทางการตลาดจากบริษัทได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อปฏิบัติตามกฎหมาย กฎเกณฑ์ ระเบียบ ประกาศต่างๆ ที่เกี่ยวข้อง
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อการปฏิบัติตามสัญญาระหว่างบริษัทกับท่าน หรือเพื่อใช้ในการดำเนินตามคำขอใช้บริการของท่านก่อนเข้าทำสัญญากับบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัท หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้แก่บริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทหรือบุคคลอื่น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อประโยชน์ในการดำเนินกิจการของบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อการดำเนินการอื่นใดที่ใกล้เคียงหรือมีลักษณะเดียวกันกับบรรดาวัตถุประสงค์ที่กำหนดไว้ข้างต้น
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            อนึ่ง ในกรณีที่บริษัทมีความจำเป็นในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์
            ในการปฏิบัติตามสัญญาระหว่างบริษัทกับท่าน หรือเพื่อใช้ในการดำเนินตามคำขอใช้บริการของท่านก่อนเข้าทำ
            สัญญากับบริษัท หากปรากฏว่าท่านไม่ให้ข้อมูลส่วนบุคคลแก่บริษัท อาจส่งผลกระทบให้บริษัทไม่อาจปฏิบัติตาม
            สัญญาหรือให้บริการแก่ท่านอย่างถูกต้องครบถ้วนตามที่กำหนดในสัญญาต่อไปได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทอาจต้องเก็บรวบรวม ใช้ ประมวลผลและเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวโดยอาศัยฐาน
            ทางกฎหมาย ซึ่งกำหนดให้บริษัทมีสิทธิดำเนินการได้ ซึ่งรวมถึงแต่ไม่จำกัดเพียงฐานดังต่อไปนี้ หรือโดยได้รับความ
            ยินยอมจากท่านโดยชัดแจ้ง
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล ซึ่งเจ้าของข้อมูลส่วนบุคคล
            (Data Subject) ไม่สามารถให้ความยินยอมได้ ไม่ว่าด้วยเหตุใดก็ตาม
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เพื่อเป็นการดำเนินกิจกรรมโดยชอบด้วยกฎหมายที่มีการคุ้มครองที่เหมาะสมของมูลนิธิ สมาคม หรือ
            องค์กรที่ไม่แสวงหากำไรที่มีวัตถุประสงค์เกี่ยวกับการเมือง ศาสนา ปรัชญา หรือสหภาพแรงงาน
            ให้แก่สมาชิก ผู้ซึ่งเคยเป็นสมาชิก หรือผู้ซึ่งมาติดต่ออย่างสม่ำเสมอกับมูลนิธิ สมาคม หรือองค์กรที่ไม่
            แสวงหากำไรตามวัตถุประสงค์ดังกล่าว โดยไม่เปิดเผยข้อมูลส่วนบุคคลออกภายนอก มูลนิธิ สมาคม
            หรือองค์กรไม่แสวงหากำไรนั้น
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เป็นข้อมูลที่เปิดเผยต่อสาธารณะด้วยความยินยอมโดยชัดแจ้งของเจ้าของข้อมูลส่วนบุคคล (Data Subject)
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เป็นการจำเป็นเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตาม หรือการใช้สิทธิเรียกร้องตาม
            กฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	เป็นการจำเป็นในการปฏิบัติตามกฎหมายเพื่อให้บรรลุวัตถุประสงค์เกี่ยวกับ (ก) เวชศาสตร์ป้องกัน
            หรืออาชีวเวชศาสตร์ การประเมินความสามารถในการทำงานของลูกจ้าง การวินิจฉัยโรคทาง
            การแพทย์ การให้บริการด้านสุขภาพหรือด้านสังคม การรักษาทางการแพทย์ การจัดการด้านสุขภาพ
            หรือระบบ และการให้บริการด้านสังคมสงเคราะห์ (ข) ประโยชน์สาธารณะด้านการสาธารณสุข (ค)
            การคุ้มครองแรงงาน การประกันสังคม หลักประกันสุขภาพแห่งชาติ สวัสดิการเกี่ยวกับการ
            รักษาพยาบาลของผู้มีสิทธิตามกฎหมาย การคุ้มครองผู้ประสบภัยจากรถ หรือการคุ้มครองทางสังคม
            (ง) การศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ หรือประโยชน์สาธารณะอื่น หรือ (จ)
            ประโยชน์สาธารณะที่สำคัญ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ท่านสามารถสอบถามข้อมูลเพิ่มเติมโดยการติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลเมื่อบริษัทเก็บ
            รวบรวม ใช้ ประมวลผลและเปิดผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่นเมื่อท่านได้ให้ความยินยอม
            ท่านอาจเพิกถอนความยินยอมได้ ณ เวลาใด ๆ โดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ตามรายละเอียดที่
            กำหนดในข้อ 11. หากท่านเพิกถอนความยินยอม บริษัทยังอาจต้องประมวลผลข้อมูลส่วนบุคคลเพื่อปฏิบัติตาม
            กฎหมายหรือเพื่อปกป้องประโยชน์ได้เสียของบริษัท ทั้งนี้ บริษัทจะอธิบายให้ท่านทราบในเวลาที่มีการเพิกถอน
            ความยินยอมว่า ข้อมูลใดที่บริษัทยังคงมีหน้าที่ในการเก็บรวบรวมหรือประมวลผลข้อมูลส่วนบุคคลเพื่อ
            วัตถุประสงค์ของการปฏิบัติตามกฎหมาย
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            นอกจากนี้ บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์อื่น ๆ เพิ่มเติมที่
            สอดคล้องหรือเป็นไปในทำนองเดียวกับวัตถุประสงค์ที่ระบุข้างต้น รวมทั้งวัตถุประสงค์ในการทำการวิจัยทาง
            ประวัติศาสตร์ สถิติ หรือวิทยาศาสตร์ เพื่อวัตถุประสงค์ในการจัดเก็บข้อมูล (archives) เพื่อประโยชน์ส่วนรวม ใน
            กรณีที่เป็นไปได้ บริษัทจะไม่ใช้ข้อมูลที่สามารถระบุตัวตนได้เพื่อวัตถุประสงค์ดังกล่าวข้างต้น หรือ บริษัทจะ
            ดำเนินการตามขั้นตอนเพื่อจำกัดขอบเขตของข้อมูลส่วนบุคคลที่บริษัทจะใช้ในการทำการวิจัยหรือจัดเก็บข้อมูล
            สำรอง รวมทั้ง บริษัทอาจใช้ข้อมูลนามแฝง (pseudonymous) เพื่อหลีกเสี่ยงการใช้ช้อมูลส่วนบุคคลของท่าน

            <br /><br />
            5. ผู้รับข้อมูลส่วนบุคคลของท่าน
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทตระหนักถึงความสำคัญในการทำให้มั่นใจถึงการป้องกันข้อมูลส่วนบุคคลที่เพียงพอ บริษัทพยายาม
            ที่จะจำกัดการเข้าถึงข้อมูลส่วนบุคคลให้แก่บุคคลที่มีความจำเป็นที่จะต้องเข้าถึงข้อมูลดังกล่าวเพื่อปฏิบัติหน้าที่ที่มี
            อยู่ พนักงาน บุคลากรของบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน
            และ/หรือพันธมิตรทางธุรกิจของบริษัท รวมทั้งบุคคลภายนอกที่มีสัญญาให้บริการแก่บริษัทเกี่ยวกับการเก็บ
            รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลข้างต้นและคู่สัญญาอื่น ๆ ที่กระทำในนามบริษัทจะเป็นผู้ได้รับและเก็บ
            รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่น บริษัทจะเปิดเผยข้อมูลส่วนบุคคลแก่บริษัทเหล่านั้นเท่าที่จำเป็น
            เพื่อประมวลผลข้อมูลส่วนบุคคลเพื่อการให้บริการแก่ท่านและเพื่อปกป้องส่วนได้เสียของบริษัทเท่านั้น และตกลงที่
            จะป้องกันข้อมูลส่วนบุคคลของท่านจากการใช้ การเข้าถึงหรือการเปิดเผยโดยไม่ได้รับอนุญาต ท่านอาจติดต่อ
            เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลตามรายละเอียดที่กำหนดในช้อ 1 1. เพื่อสอบถามข้อมูลเพิ่มเติมเกี่ยวกับ
            ประเภทของผู้ให้บริการที่บริษัทจะมีการเปิดเผยข้อมูลส่วนบุคคลของท่านให้ทราบ บริษัทอาจเปิดเผยข้อมูลการ
            ติดต่อของท่นในสมุดรายชื่อเจ้าหน้าที่ให้แก่พนักงานของบริษัทและบุคคลทั่วไป อย่างไรก็ตาม ท่านมีสิทธิขอให้ลบ
            ข้อมูลของท่านออกจากบริษัท ภายใต้หลักเกณฑ์ เงื่อนไข ระยะเวลาที่บริษัทกำหนด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทอาจให้ข้อมูลส่วนบุคคลของท่าน แก่บริษัทอื่นใดหรือหน่วยงานใด ๆ เช่น หน่วยงานราชการ
            หน่วยงานภาครัฐ หน่วยงานที่กำกับดูแลการให้บริการ หรือหน่วยงานกำกับดูแลบริษัท หรือหน่วยงานที่บริษัทเป็น
            สมาชิก หน่วยงานราชการที่ควบคุมในเรื่องการตรวจคนเข้าเมือง ภาษี ความมั่นคงของชาติและอาชญากรรม
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            นอกจากนี้ ท่านตกลงยินยอมให้บริษัทเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านให้แก่บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน
            หรือพันธมิตรทางธุรกิจของบริษัทเพื่อวัตถุประสงค์ในการดำเนินการกิจการของบริษัท เพื่อการปฏิบัติตามนโยบายของบริษัท
            เพื่อปฏิบัติตามสัญญาหรือให้บริการระหว่างบริษัทกับท่าน เพื่อปกป้องประโยชน์ได้เสียหรือสิทธิโดยชอบด้วยกฎหมายของบริษัท เพื่อประโยชน์สาธารณะ หรือประกาศที่บริษัทจะกำหนดเป็นกรณีๆ ไป
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทขอเรียนให้ท่านทราบว่า เว็บไซต์ของบริษัทจะมีการเชื่อมต่อไปยังเว็บไซต์ของบุคคลที่สามซึ่งเว็บไซต์เหล่านั้นอาจมีนโยบายความเป็นส่วนตัวที่แตกต่างจากของบริษัท
            ท่านจึงควรศึกษานโยบายความเป็นส่วนตัวของเว็บไซต์นั้น ๆ เพื่อเข้าใจถึงรายละเอียดการคุ้มครองข้อมูลส่วนบุคคล และเพื่อตัดสินใจในการเปิดเผยข้อมูลส่วนบุคคลให้กับเว็บไซต์ของบุคคลที่สาม
            ทั้งนี้ บริษัทจะไม่รับผิดชอบต่อความสูญเสียหรือความเสียหายอย่างใด ๆ อันเกิดจากการกระทำของเว็บไซต์ของบุคคลที่สามทุกกรณี


            <br /><br />
            6. การโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทอาจโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศเพื่อวัตถุประสงค์ในการดำเนินกิจการของบริษัทเท่าที่จำเป็น ทั้งนี้
            ท่านตกลงและยินยอมให้บริษัทส่งข้อมูลส่วนบุคคลของท่านออกนอกประเทศไทยไปยังบุคคลหรือหน่วยงานที่อยู่ในประเทศอื่น
            หรือภายใต้เขตอำนาจกฎหมายของประเทศอื่น ไม่ว่ากฎหมายคุ้มครองข้อมูลส่วนบุคคลในประเทศนั้นอาจถึงเกณฑ์หรือไม่ถึงเกณฑ์มาตรฐานของกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย
            ทั้งนี้ บริษัทจะปฏิบัติตามขั้นตอนที่เหมาะสมในการคุ้มครองรักษาความปลอดภัยของข้อมูลส่วนบุคคลของท่านในระดับเดียวกับกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย


            <br /><br />
            7. การรักษาความมั่นคงปลอดภัยและความลับของข้อมูลส่วนบุคคล
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เพื่อสร้างความมั่นใจในการบริหารจัดการของบริษัท เพื่อการป้องกันความเสี่ยงอันอาจทำให้ข้อมูลส่วนบุคคลถูกเข้าถึงโดยมิชอบ
            รั่วไหล ถูกเปลี่ยนแปลงแก้ไข สูญหาย บริษัทได้จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลที่เหมาะสมตามมาตรฐานที่กฎหมายกำหนด
            บริษัทถือปฏิบัติตามนโยบายความมั่นคงปลอดภัยสารสนเทศ (Information Security Policy)
            รวมทั้งปฏิบัติตามมาตรฐานสากลด้านการรักษาความปลอดภัยสารสนเทศที่เป็นที่ยอมรับ และการบริหารความต่อเนื่องทางธุรกิจ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทมีมาตรการปกป้องความเป็นส่วนตัวของท่าน โดยการจำกัดสิทธิการเข้าถึงข้อมูลส่วนบุคคลของท่าน
            จะกำหนดให้เฉพาะบุคคลที่จำเป็นต้องใช้ข้อมูลส่วนบุคคลดังกล่าวในการนำเสนอสินค้าและ/หรือบริการของบริษัท
            เพื่อการให้บริการของบริษัท และ/หรือเพื่อวัตถุประสงค์ที่กำหนดในข้อ 4 ข้างต้น เช่น พนักงานบริษัท
            ซึ่งเป็นบุคคลที่บริษัทอนุญาตให้เข้าถึงข้อมูลส่วนบุคคลนั้น จะต้องยึดมั่นและปฏิบัติตามมาตรการการปกป้องข้อมูลส่วนบุคคลของบริษัท
            อย่างเคร่งครัด ตลอดจนการรักษาความลับของข้อมูลส่วนบุคคลดังกล่าว
            โดยบริษัทมีมาตรการป้องกันทั้งทางกายภาพและทางอิเล็กทรอนิกส์เป็นไปตามมาตรฐานการกำกับดูแลที่บังคับใช้เพื่อปกป้องข้อมูลส่วนบุคคล
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เมื่อบริษัททำสัญญา หรือ ข้อตกลงกับบุคคลที่สาม บริษัทจะกำหนดมาตรการรักษาความปลอดภัยของข้อมูลส่วนบุคคล การรักษาข้อมูลที่เป็นความลับที่เหมาะสม
            เพื่อสร้างความมั่นใจในความปลอดภัยของข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม

            <br /><br />
            8. ระยะเวลาการเก็บข้อมูล
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตามความจำเป็นและภายใต้กรอบระยะเวลาที่กฎหมายกำหนด
            ท่านสามารถตรวจสอบข้อมูลเกี่ยวกับระยะเวลาที่บริษัทเก็บรักษาข้อมูลส่วนบุคคลของท่าน
            โดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ 11

            <br /><br />
            9. สิทธิของท่าน
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ในเวลาใดก็ตาม ท่านมีสิทธิดังต่อไปนี้เกี่ยวกับข้อมูลส่วนบุคคลของท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านที่บริษัทมีรวมทั้งสิทธิในการขอให้แก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่ครบถ้วน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิในการขอสำเนาข้อมูลส่วนบุคคลในรูปแบบอิเล็กทรอนิกส์ที่ท่านอาจส่งให้บุคคลภายนอกหรือขอให้บริษัทส่งโดยตรง
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิที่จะคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ทางการตลาดและวัตถุประสงค์อื่นใดตามที่กฎหมายกำหนด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิที่จะขอให้ลบข้อมูลส่วนบุคคลของท่านเมื่อไม่มีความจำเป็น สำหรับวัตถุประสงค์ที่มีการจัดเก็บ รวมทั้งสิทธิที่จะจำกัด
            ขอบเขตการประมวลผลข้อมูลส่วนบุคคล ในกรณีที่ไม่สามารถให้ลบได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิขอให้ผู้ควบคุมข้อมูลส่วนบุคคลระงับการใช้ข้อมูลส่วนบุคคลได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิร้องขอให้บริษัทดำเนินการให้ข้อมูลส่วนบุคคลนั้นถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            -	สิทธิที่จะร้องเรียนกับหน่วยงานที่ควบคุมในกรณีที่ท่านเชื่อว่ามีการละเมิดสิทธิท่าน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทั้งนี้ การใช้สิทธิของท่านจะต้องอยู่ภายข้อกำหนด ประกาศ ระเบียบที่บริษัทกำหนด ซึ่งจะเป็นไปตามหลักเกณฑ์ของกฎหมายคุ้มครองข้อมูลส่วนบุคคล
            รวมถึงนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัท และหลักเกณฑ์อื่น ๆ ที่บริษัทกำหนด โดยในการใช้สิทธิข้างต้น
            ท่านจะต้องส่งคำร้องเป็นลายลักษณ์อักษรมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ
            11. ของประกาศฉบับนี้ และการพิจารณาคำร้องดังกล่าวเป็นดุลยพินิจของบริษัทแต่เพียงผู้เดียว คำวินิจฉัยของบริษัทที่เกี่ยวข้องกับคำร้องขอใช้สิทธิของท่านถือเป็นที่สุด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทั้งนี้ ในกรณีที่ท่านขอให้บริษัท ลบ ทำลาย จำกัดการเก็บรวบรวม ใช้ ประมวลผลหรือเปิดเผยข้อมูลส่วนบุคคล ระงับการใช้ชั่วคราว
            แปลงข้อมูลส่วนบุคคลที่ไม่สามารถระบุตัวตนได้ หรือถอนความยินยอม อาจทำให้เกิดข้อจำกัดกับบริษัทในการทำธุรกรรมหรือให้บริการแก่ท่านได้

            <br /><br />
            10. การเพิกถอนความยินยอม
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            หากท่านไม่ประสงค์ให้บริษัทเก็บรวบรวม ใช้ ประมวลผล หรือเปิดเผยข้อมูลส่วนบุคคลของท่านอีกต่อไป
            ท่านสามารถเพิกถอนความยินยอมได้โดยการทำคำร้องแจ้งมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัท
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทั้งนี้ การเพิกถอนความยินยอมข้อมูลส่วนบุคคลดังกล่าว จะต้องอยู่ภายใต้เงื่อนไข ข้อกำหนด ประกาศ
            หรือระเบียบที่กำหนดในกฎหมายคุ้มครองข้อมูลส่วนบุคคล
            รวมถึงนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท และหลักเกณฑ์อื่นๆ ที่บริษัทกำหนด
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            อนึ่ง การถอนความยินยอม อาจทำให้เกิดข้อจำกัดกับบริษัทในการทำธุรกรรมหรือให้บริการแก่ท่านได้
            <br /><br />
            11. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            หากท่านประสงค์จะใช้สิทธิตามที่กำหนดในข้อ 9 หรือต้องการเพิกถอนความยินยอมในข้อ 10 หรือมีข้อสงสัยเกี่ยวกับการเก็บรวบรวม
            ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล โปรดติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลตามรายละเอียดด้านล่างนี้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ที่อยู่ :บริษัท ไวท์พลาย จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 24 ถ.เพชรบุรีตัดใหม่
            แขวงบางกะปี เขตห้วยขวาง กรุงเทพมหานคร 10310
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            หมายเลขโทรศัพท์ : 0 2257 7000
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            อีเมลแอดเดรส : iclaim@inet.co.th
            <br /> <br />
            12. กรณีลูกค้าหรือผู้ใช้บริการเป็นบุคคลธรรมดาที่ยังไม่บรรลุนิติภาวะ
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            กรณีที่ท่านเป็นบุคคลธรรมดาและมีอายุยังไม่ครบ 20 ปีบริบูรณ์ หรือยังไม่บรรลุนิติภาวะตามกฎหมาย ท่านยืนยันว่า ท่านมีอายุเกินกว่า 15 ปี
            และสามารถทำนิติกรรมและการใด ๆ ซึ่งต้องทำเองเป็นการเฉพาะตัว หรือเป็นการสมแก่ฐานานุรูปแห่งตนด้วยตนเองได้โดยมีผลผูกพันตามกฎหมาย
            ซึ่งรวมถึงแต่ไม่จำกัดเพียงการซื้อสินค้า หรือใช้บริการใด ๆ จากบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน
            และการรับทราบและยอมรับที่จะปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            กรณีที่ท่านเป็นบุคคลธรรมดาที่มีอายุไม่เกิน 15 ปี ท่านยืนยันว่าท่านได้รับความยินยอมจากผู้แทนโดยชอบธรรมตามกฎหมายในการซื้อขายสินค้า
            หรือใช้บริการใด ๆ จากบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน
            โดยท่านและผู้แทนโดยชอบธรรมตามกฎหมายของท่านรับทราบและยอมรับที่จะปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ และยินดีส่งหลักฐานที่เกี่ยวข้องให้แก่บริษัทตามที่บริษัทร้องขอ
            <br /><br />
            13. การแก้ไขเปลี่ยนแปลง
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            บริษัทขอสงวนสิทธิในการแก้ไขเปลี่ยนแปลงนโยบายนี้ไม่ว่าด้วยเหตุผลใดก็ตามที่เห็นสมควร รวมถึงใน
            กรณีที่เป็นการปฏิบัติตามกฎหมาย นโยบายของรัฐบาล กฎ ประกาศ ระเบียบ หรืออื่น ๆ ที่เกี่ยวข้อง เมื่อมีการ
            เปลี่ยนแปลงใด ๆ บริษัทจะแจ้งผ่านทางอีเมลของท่านเป็นลายลักษณ์อักษร ซึ่งการแก้ไขเปลี่ยนแปลงดังกล่าวจะมี
            ผลทันทีเมื่อมีการแจ้งเป็นลายลักษณ์อักษรแก่ท่าน และท่นรับทราบและยินยอมปฏิบัติตามนโยบายคุ้มครอง
            ข้อมูลส่วนบุคคลฉบับแก้ไขทุกประการ ท่นควรตรวจสอบและอ่านรายละเอียดของนโยบายคุ้มครองข้อมูลส่วน
            บุคคลที่บริษัทชี้แจงผ่านทางอีเมลเป็นประจำ
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ให้ประกาศฉบับนี้มีผลนับแต่วันที่ 1 มกราคม 2566 เป็นต้นไป หรือจนกว่าจะมีคำสั่งเปลี่ยนแปลง
            <br /><br /><br />

            <div
                className='pr-5'
                style={{
                    display: 'grid',
                    justifyContent: 'flex-end',
                    textAlign: 'center'
                }} >
                {/* <Typography.Text>(นายกำพล กิจชระภูมิ)</Typography.Text>
                <Typography.Text>กรรมการผู้จัดการ</Typography.Text> */}
                <Typography.Text>บริษัท ไวท์พลาย จำกัด</Typography.Text>

            </div>


        </div>
    )
}

export default ModalPoricy